import api from '../api';

export const getListPage = async () => {
    const result = await api.get('/admin/pages');
    return result.data;
}

export const getOnePage = async (id) => {
    const result = await api.get(`/admin/pages/${id}`);
    return result.data.page[0];
}

export const createPage = async (data) => {
    try {
        const response = await api.post('/admin/pages', data);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updatePage = async (data, id, lang) => {
    return await api.post(`/admin/pages/${id}`, data, {
        headers: {
            "Accept-Language": lang
        }
    });
}

export const deletePage = async (id) => {
    try {
        const response = await api.delete(`/admin/pages/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}

export const updateStatusPage = async (id) => {
    try {
        const response = await api.put(`/admin/status/pages/${id}`);
        return JSON.stringify(response.data);
    } catch (error) {
        throw error;
    }
}
